/**
 * 加盟店入力画面のバリデーションルール
 * @param {object} common
 * @param {object} unique
 */
export const ValidationRulesFun = (common, unique) => {
  const copy = JSON.parse(JSON.stringify(common))
  for (let key in unique) {
    if (common[key]) {
      copy[key].push(...unique[key])
    } else {
      copy[key] = unique[key]
    }
  }
  return copy
}

/**
 * 加盟店入力画面のバリデーション共通
 */
export const ValidationRulesCommon = {
  cash_total: [
    // 現金価格合計
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'integer', event: 'input'}
  ],
  down_payment: [
    // 頭金
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'integer', event: 'input'},
    {rule: 'lt:cash_total:numeric', event: 'input'}
  ],
  finance_category_name: [
    // 金融商品カテゴリー
    {rule: 'required', event: 'blur,change', action: 'select'},
    {rule: 'string', event: 'blur,change', action: 'select'}
  ],
  payment: [
    // お支払い方法
    {rule: 'required', event: 'blur,change', action: 'select'}
  ],
  split_number: [
    // 分割回数
    {rule: 'required_if:payment,分割払い,分割払い・ボーナス併用', event: 'blur,change', action: 'select'},
    {rule: 'between:3,60,回', event: 'blur,change'}
  ],
  bonus_combined_addition_amount: [
    // ボーナス併用加算額
    {rule: 'required_if:payment,分割払い・ボーナス併用', event: 'blur,input', action: 'input'},
    {rule: 'unit:1000', event: 'input'}
  ],
  bonus_combined_payment: [
    // バリデーション用の値
    {rule: 'percent:50:remaining_money', event: 'blur'}
  ],
  bonus_combined_month1: [
    // ボーナス加算月1
    {
      rule: 'required_if:payment,分割払い・ボーナス併用',
      event: 'blur,change',
      error_add: 'bonus_combined_month',
      action: 'select'
    }
  ],
  bonus_combined_month2: [
    // ボーナス加算月2
    {
      rule: 'required_if:payment,分割払い・ボーナス併用',
      event: 'blur,change',
      error_add: 'bonus_combined_month',
      action: 'select'
    }
  ],
  bonus_once_month: [
    // ボーナス一括月
    {rule: 'required_if:payment,ボーナス一括払い,ボーナス2回払い', event: 'blur,change', action: 'select'},
    {rule: 'date', event: 'blur,change'}
  ],
  bonus_twice_month: [
    // ボーナス二括月
    {rule: 'required_if:payment,ボーナス2回払い', event: 'blur,change', action: 'select'},
    {rule: 'date', event: 'blur,change'}
  ],
  payment_period_start: [
    // 支払期間 開始
    {rule: 'required', event: 'change,blur', action: 'select'}
    // { rule: 'date', event: 'change,blur', },
  ],
  payment_amount_once: [
    // 支払金額 第1回目
    {
      rule: 'calc_remainder:payment,ボーナス２回払い:split_total_pay:payment_amount_second',
      event: 'blur',
      action: 'input'
    },
    {rule: 'limit:1,lower', event: 'input', message: '支払金額の1回目は必ず0円以上の金額が必要です。'}
  ],
  payment_amount_second: [ // 支払金額 第2回目以降
      // {rule: 'required_if:payment,分割払い,分割払い・ボーナス併用', event: 'blur', action: 'select'},
      {rule: 'limit:1,lower', event: 'input', message: '支払金額の2回目以降は必ず0円以上の金額が必要です。'}
  ],
  person_charge: [
    // 担当者名
    {rule: 'required', event: 'blur', action: 'input'},
    {rule: 'maxlen:20', event: 'input', action: 'input'}
  ]
}

/**
 * 加盟店入力画面のバリデーション信販
 */
export const ValidationRulesCredit = {}

/**
 * 加盟店入力画面のバリデーション自社割賦
 */
export const ValidationRulesInstallment = {
  product: [],
  product_other_name: [
    {rule: 'required_if:product,その他', event: 'blur', action: 'input'},
    {rule: 'string', event: 'input'},
    {rule: 'maxlen:50', event: 'input'}
  ],
  service_start_date: [{rule: 'date', event: 'blur,change'}],
  service_end_date: [{rule: 'date', event: 'blur,change'}]
}
